
import Vue from "vue";
import Navigation_bar from "./components/Navigation_bar.vue";
import Pre_footer from "./components/Pre_footer.vue";
import Footer from "./components/Footer.vue";
import "@/assets/css/main.css";
import ModalOpenDay from "./components/OpenDay/Modals/modalOpenDay.vue";
import ModalOpenFest from "./components/OpenDay/Modals/modalOpenFest.vue";
const Whatsapp = () => import("@/components/Home_Sections/Whatsapp.vue");
export default Vue.extend({
  name: "App",
  // mounted() {
  //   const script = document.createElement('script');
  //   script.src = 'https://zyxmelinux.zyxmeapp.com/zyxme/chat/src/chatwebclient.min.js';
  //   script.setAttribute('integrationid', '667e0ef6f9ad0dce228fc916');
  //   script.async = true;
  //   script.onload = () => {
  //     console.log('scrip cargado');
  //   };
  //   script.onerror = () => {
  //     console.error('script no cargado');
  //   };
  //   document.body.appendChild(script);
  // },
  components: {
    Navigation_bar,
    ModalOpenDay,
    ModalOpenFest,
    Footer,
    Pre_footer,
    Whatsapp
  },
  computed: {
    esRutaEspecial() {
      // Puedes definir todas las rutas especiales aquí (como partners)
      return ["/pre-columbia", "/landingProgramaIngles", "/openday2024", "/openFest", "/LandingAviacionComercial", "/LandingAltaCocina"].includes(this.$route.path);
    },
  },
  data: () => ({
    //
  }),
});
